<template>
    <div><!-- class="container" -->
        <header role="banner">
            <nav class="navbar navbar-expand-lg navbar-dark bg-dark"> <!-- bg-dark -->
                <div class="container-fluid">
                    <!--                                        <a class="navbar-brand " href="index.html">&nbsp;</a>-->
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNav">
                        <ul class="navbar-nav ml-auto">
                            <NavLink to="/" name="Home"></NavLink>
                            <NavLink to="/akce" name="Kalendář"></NavLink>
                            <NavLink to="/kontakt" name="Kontakt"></NavLink>
                        </ul>
                        <div class="navbar-nav ml-auto">
                        </div>
                    </div>
                </div>
            </nav>
        </header>
        <div class="slider-item bg-image" style="">
            <div class="container">
                <div class="row slider-text align-items-center justify-content-center">
                    <div class="col-lg-9 text-center col-sm-12 element-animate fadeInUp element-animated">
                        <br>
                        <h1 class="text-light display-4"><span class="main-heading ">Vinárna Hradní sklípek</span></h1>
                    </div>
                </div>
            </div>
        </div>
        <main style="margin-top:2em">
            <slot></slot>

        </main>
<!--        <div class="container">-->
<!--            <footer class="d-flex justify-content-center">-->
<!--                2020-->
<!--            </footer>-->
<!--        </div>-->
    </div>
</template>

<script>
    // import VLink from './../components/VLink.vue'

    import NavLink from "../components/NavLink.vue";

    export default {
        components: {
            NavLink
        }
    }
</script>

<style scoped>
    .bg-image {
        background-image: url('/bg2-2.jpg');
        width: 100%;
        height: 328px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .main-heading {
        /*background-color: #343a40 !important;*/
        box-shadow: 0 3px 0 0 transparent inset,
        0 -3px 0 0 transparent inset;
    }

    span.main-heading {
        display: inline-block;
    }

    /*.container {*/
    /*    max-width: 600px;*/
    /*    margin: 0 auto;*/
    /*    padding: 15px 30px;*/
    /*    background: #f9f7f5;*/
    /*}*/
</style>